import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AuditLogPanelEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const auditLogPanelEntryPoint: EntryPoint<AuditLogPanelEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<AuditLogPanelEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-proactive-support-audit-log-panel" */ './AuditLogPanel.tsx',
		),
		getPreloadProps: () => ({}),
	});
